import Credits from "./Credits";
import Game from "./Game";
import Keybindings from "./Keybindings";
import MainMenu from "./MainMenu";
import NewGame from "./NewGame";
import Settings from "./Settings";

export default { Credits, Game, Keybindings, MainMenu, NewGame, Settings };
